export class ModalWarningEventType {

	static MODAL_WARNING = {
		OK: 'OK',
		CANCEL: 'CANCEL',
		TRUE_MODAL: 'TRUE_MODAL',
		MODAL_CLOSE: 'MODAL_CLOSE'
	};

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/transaction-history/modal-warning/modal-warning.event.type.ts